import React, { Fragment } from 'react'
import { Text, View, StyleSheet } from '@react-pdf/renderer';
import NoData from './NoData';

const History = ({ data }) => {
    const styles = StyleSheet.create({
        container: {
            width: "100%",
        },
        subContainer: {
            width: "100%",
            marginTop: "20px",
            flexDirection: 'column',
            paddingLeft: '15px'
        },
        textHeader: {
            fontSize: '11px',
            fontWeight: 'bold',
            color: '#525353',
        },
        timeView: {
            flexDirection: "row",
            alignItems: "center",
            fontSize: '11px',
            fontWeight: 'bold',
            color: '#525353',
            opacity: "0.5",
            marginRight: "5px",

        },
        time: {
            borderRightColor: '#525353',
            borderRightStyle: 'solid',
            borderRightWidth: '1px',
            paddingRight: "5px",
            marginRight: "5px",
            lineHeight: "1px"

        },
        name: {
            borderRightColor: '#525353',
            borderRightStyle: 'solid',
            borderRightWidth: '1px',
            paddingRight: "5px",
            marginRight: "5px",
            lineHeight: "1px",

        },
        action: {
            lineHeight: "1px",
        },
    });
    
    return (
        <Fragment>
            {
                data && data?.length > 0 ?
                    <View style={styles.container}>
                        {
                            data && data?.map((item, index) => (
                                <View style={styles.subContainer}>
                                    <Text style={styles.textHeader}>{item?.body}</Text>
                                    <View style={styles.timeView}>
                                        <Text style={styles.time}>{item?.created_at}</Text>
                                        <Text style={styles.name}>{item?.user_name}</Text>
                                        <Text style={styles.action}>Action : {item?.status}</Text>
                                    </View>
                                </View>

                            ))
                        }
                    </View> : <NoData title='History'/>
            }
        </Fragment>
    )
}

export default History